module.exports = __webpack_public_path__ + "img/order-empty.206ab0b0.png";